import { Button } from "components/Button/Button";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { SelectBox } from "components/Select/Select";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import React, { useEffect, useState } from "react";
import { InputTextType, InputTypes, MessageType } from "types/enum";
import { trans } from "utils/helpers";
import { BasicSettings } from "./components/BasicSettings";

import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
import { InputLoad } from "components/InputLoading/inputLoading";
import { KeyWord } from "components/KeyWord/KeyWord";
import { AvailableService } from "utils/constants";
import { getControllerLookupConfig, getDataAsync } from "../../api";
import { InputAvailable } from "../InputAvailable";
import { CheckboxSettings } from "./components/CheckboxSettings";
import { DateTimeSettings } from "./components/DateTimeSettings";
import { MessageSettings } from "./components/MessageSettings";
import { PositionSettings } from "./components/PositionSettings";
import { PriceSettings } from "./components/PriceSettings";
import { ProgressBarSettings } from "./components/ProgressBarSettings";
import { RadioSelectSettings } from "./components/RadioSelectSettings";
import { TextInputSettings } from "./components/TextInputSettings";
import { TimeLengthSettings } from "./components/TimeLengthSettings";

interface InputSettingProps {
  object: any;
  systemKeys: any;
  condition?: any;
  Formul?: any;
  filledSystemKey: "create" | "duplicate" | "edit";
  handleNewSetting: (e: any, Formul: any, condition: any) => void;
  onHide: (e: boolean) => void;

}

export const InputSetting: React.FC<InputSettingProps> = ({
  object,
  filledSystemKey,
  systemKeys,
  condition,
  Formul,
  handleNewSetting,
  onHide,
  
}) => {
  const [keyWords, setKeyWords] = useState<any>(object?.Keywords || []);
  const [keys, setKeys] = useState<any>(object?.Keys || []);
  const [indexTextBox, setIndexTextBox] = useState<string>(
    object?.InputType ? InputTextType[object.InputType] : "text"
  );
  const [minLengthBox, setMinLengthBox] = useState<any>(null);
  const [controllerLookupConfig,setControllerLookupConfig]=useState<any>([])
  const [controllerLookupConfigLoading,setControllerLookupConfigLoading]=useState<any>(false)
  const [url,setUrl]=useState<any>({baseUrl:Object.values(AvailableService)[0],endpoint:''})
    const [data,setData]=useState<any>()
  const [dataLoading,setdDataLoading]=useState<any>(false)

  const [maxLengthBox, setMaxLengthBox] = useState<any>(null);
  const [resetForm, setResetForm] = useState<any>(false);
  const [modeTextBox, setModeTextBox] = useState<"create" | "view">("create");
  const [textType, setTextType] = useState<"text" | "number" | "other">("text");
  const [dateDefaultValue, setDateDefaultValue] = useState<string | null>(null);
  const [inputTypeUrl, setInputTypeUrl] = useState<any>(
    object?.inputType ? object?.inputType : "AutoCompleteDictionary"
  );
  const [direction, setDirection] = useState(
    object?.direction === "true" || object?.direction === true
  );
  const [datePickerState, setDatePickerState] = useState<"withTime" | "normal">(
    object?.DatePickerState || "normal"
  );
  const [defaultValueDateTimeNow, setDefaultValueDateTimeNow] =
    useState<boolean>(object?.defaultValueDateTimeNow);
  const [listTypeText, setListTypeText] = useState<any>();
  const checkTypeText = (e: string) => {
    setIndexTextBox(e);
    setResetForm(true);
  };

  function transformFormula(formula, isCondition = false) {
    //  formula= formula.replace(/Number\(\s*([^)]+)\s*\)/g, '$1')

    //     // حذف DynamicFormRef.current?.
    //     .replace(/DynamicFormRef\.current\?\./g, '')

    //     // حذف .value
    //     .replace(/\.value/g, '')

    //     // حذف علامت سوال ها
    //     .replace(/\?/g, '')

    //     // حذف فاصله های اضافی
    //     .replace(/\s+/g, ' ')

    //     // حذف فاصله اضافی ابتدای و انتهای رشته
    //     .trim();
    // 1. Trim spaces inside quoted strings
    formula = formula.replace(/(["'])(.*?)\1/g, (match, quote, content) => {
      return quote + content.trim() + quote;
    });

    // 2. Convert string booleans/numbers inside quotes
    formula = formula.replace(
      /(["'])(0|1|False|True)\1/g,
      (match, quote, value) => {
        const map = { "0": "false", "1": "true", False: "false", True: "true" };
        return `"${map[value]}"`;
      }
    );

    // 3. Replace single = with == outside quotes
    formula = formula.replace(
      /(^|[^=])=([^=])/g,
      (match, before, after, offset) => {
        const upToHere = formula.slice(0, offset + before.length);
        const quoteCount = (upToHere.match(/["']/g) || []).length;
        const insideQuotes = quoteCount % 2 !== 0;
        return insideQuotes ? match : `${before}==${after}`;
      }
    );

    // 4. Process all variables in the formula

    
    formula = formula.replace(/\b(?!\d)\w+(?:\.\w+)*\b/g, (match2, offset) => {
         const mathTokens = [
    "Math",
    "ceil",
    "floor",
    "round",
    "max",
    "min",
    "abs",
    "pow",
    "sqrt",
  ];
  function a(){



  if (mathTokens.includes(match2)) return match2;

  // اگر Math.xxx بود
  if (match2.startsWith("Math.")) return match2;

  // ===== اینجای مهم =====
  // اگر object path بود (item.Code)
  
  if (match2.includes(".")) {
    const [root, ...rest] = match2.split(".");
    return `${root}Object?.${rest.join(".")}`;
  }else{
    return match2
  }


  }
  match2=a()

      const before = formula.slice(0, offset);
      const quoteCount = (before.match(/["']/g) || []).length;

      if (quoteCount % 2 !== 0) return match2; // Inside quotes
      if (!isNaN(match2)) return match2; // A number
      if (formula.includes(`newObj.current?.${match2}`)) return match2; // already transformed

      // Check if it's part of a Math function
      const after = formula.slice(offset);

      
      if (
        before.endsWith("Math.") ||
        after.startsWith(".") ||
        [
          "Math",
          "ceil",
          "floor",
          "round",
          "max",
          "min",
          "abs",
          "pow",
          "sqrt",
        ].includes(match2) ||
        mathTokens.some(item=>match2.includes(item))
      ) {

return match2



      }

      return isCondition
        ? `DynamicFormData.${match2}`
        : `newObj.current?.${match2}`;
    });

    return formula;
  }

  /* function transformFormula(formula, isCondition = false) {
  // 1. Trim spaces inside quoted strings
  formula = formula.replace(/(["'])(.*?)\1/g, (match, quote, content) => {
    return quote + content.trim() + quote;
  });

  // 2. Replace "0"/"1"/"True"/"False" inside quotes with "false"/"true"
  formula = formula.replace(/(["'])(0|1|False|True)\1/g, (match, quote, value) => {
    const map = { "0": "false", "1": "true", "False": "false", "True": "true" };
    return `"${map[value]}"`;
  });

  // 3. Replace standalone = with == (not inside quotes, not already ==)
  formula = formula.replace(/(^|[^=])=([^=])/g, (match, before, after) => {
    // Check if inside quotes
    const index = match.indexOf('=') + (before ? 1 : 0);
    const quoteCount = formula.slice(0, formula.indexOf(match) + index).match(/["']/g);
    const insideQuotes = quoteCount && quoteCount.length % 2 !== 0;
    if (insideQuotes) return match; // leave it unchanged
    return `${before}==${after}`;
  });

  // 4. Prefix variable names with obj. (outside quotes, not numbers)
  formula = formula.replace(/\b(?!\d)\w+\b/g, (match, offset) => {
    const before = formula.slice(0, offset);
    const quoteCount = (before.match(/["']/g) || []).length;
    if (quoteCount % 2 !== 0) return match; // Inside quotes
    if (!isNaN(match)) return match;        // A number
    return isCondition ?   `DynamicFormData.${match}` :    `Number(DynamicFormRef.current?.${match}?.value)`;
  });

  return formula;
} */
  /*     function transformFormula(formula) {
  return formula.replace(/\b(?!\d)\w+\b/g, (match, offset) => {
    // Count quotes before this match
    const before = formula.slice(0, offset);
    const quoteCount = (before.match(/["']/g) || []).length;

    // If inside quotes, leave it unchanged
    if (quoteCount % 2 !== 0) return match;

    // If it's a number, leave it unchanged
    if (!isNaN(match)) return match;

    // Otherwise, add obj.
    return `DynamicFormData.${match}`;
  });
} */
  /*    function transformFormula(formula) {
      
          return formula.replace(/\b(?!\d)\w+\b/g, (match) => {
            // If it's a pure number, don't prefix
            if (!isNaN(match)) return match;
            return `DynamicFormData.${match}`;
          });
        } */
const getControllerLookupConfigApi=async()=>{
  setControllerLookupConfigLoading(false)
  try{
  const res=await getControllerLookupConfig()
  setControllerLookupConfig(res?.Data)
  setUrl({...url,endpoint:res?.Data?.[0]?.DropDownUrl})
  }catch{}

  setControllerLookupConfigLoading(true)
  
}


const getControllerLookupConfigDataAsync=async()=>{
  setdDataLoading(false)
  try{
  const res=await getDataAsync(url?.baseURL,url?.endpoint)
  setData(res)
  }catch{}

  setdDataLoading(true)
  
}
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    let Formula = {};
    let condition = {};


    let data = {
      size:
        keyWords.length > 4 && object.typeName === "RadioButton"
          ? 12
          : (event.target as any).size?.value,
      hidden: (event.target as any).hidden?.checked,
      ...((object?.typeName === "Person" ||
        object?.typeName == "Position" ||
        object?.typeName === "PositionDictionary") && {
        fillWithCurrent: (event.target as any).fillWithCurrent?.checked,
      }),
      ...(object.typeName !== "Message" &&
        object.typeName !== "emptySpace" && {
          label: (event.target as any).label?.value,
          SystemKey: (event.target as any).SystemKey?.value,
          required: (event.target as any).required?.checked,
          disable: (event.target as any).disable?.checked,
          defaultValue: !defaultValueDateTimeNow
            ? object?.typeName === "checkBox"
              ? (event.target as any).defaultValue?.checked
              : object?.typeName === "date" || object?.typeName === "time"
              ? dateDefaultValue
              : object?.typeName === "ProgressBar"
              ? (event.target as any).defaultValue?.value === ""
                ? 0
                : +(event.target as any).defaultValue?.value
              : object?.typeName === "textArea"
              ? (event.target as any).defaultValue?.value.slice(0, 500)
              : object.typeName == "price"
              ? (event.target as any).defaultValue?.value
                  .slice(0, 200)
                  .replaceAll(",", "")
              : (event.target as any).defaultValue?.value.slice(0, 200)
            : null,
        }),
      ...(object.typeName === "Message" && {
        messageType: (event.target as any)?.messageType?.value,
        message: (event.target as any)?.message?.value,
      }),
      ...(object.typeName === "attachment" && {
        attachmentType: (event.target as any).attachment?.value,
      }),
         ...(object.typeName === "apiRequestConfigurator" && {
        baseUrl:url.baseUrl ,
        endpoint:url.endpoint ,

      }),
      ...(object.typeName === "simpleGrid" && {
        tbodyLength: (event.target as any)?.tbodyLength?.value,
        theadLength: (event.target as any)?.theadLength?.value,
      }),
      ...(object?.type == InputTypes.dataGrid && {
        tbodyLength: (event.target as any)?.tbodyLength?.value,
      }),
      ...((object.typeName === "selectBox" ||
        object.typeName === "RadioButton") && {
        Keywords: keyWords,
        direction: (event.target as any).direction?.value,
      }),
      ...(object?.typeName === "PositionDictionary" &&
        object?.SystemKey === "RequesterPositionId" && {
          hidden: (event.target as any).hidden?.checked,
        }),
      ...((object?.typeName === "Position" ||
        (object?.typeName === "PositionDictionary" &&
          object?.SystemKey === "RequesterPositionId")) && {
        OrganizationType: (event.target as any).OrganizationType?.value,
      }),
      ...((object.typeName === "text" ||
        object.typeName === "number" ||
        object.typeName === "textArea" ||
        object.typeName === "decimalNumber" ||
        object.typeName == "SystemNumber") && {
        placeholder: (event.target as any).placeholder?.value,
      }),
      ...(object.typeName === "decimalNumber" && {
        numberOfDecimal: (event.target as any).numberOfDecimal?.value
          ? +(event.target as any).numberOfDecimal?.value
          : 0,
      }),
      ...(object.typeName === "text" && {
        InputType: (event.target as any).InputType?.value,
      }),
      ...(object?.typeName === "price" && {
        currencyRoundingPlace: (event.target as any).CurrencyRoundingPlace
          ?.value
          ? (event.target as any).CurrencyRoundingPlace?.value
          : null,
      }),
      ...(((object.typeName === "text" && textType === "text") ||
        object?.typeName === "textArea") && {
        maxLength: (event.target as any).maxLength?.value,
      }),
      ...(object.typeName === "textArea" && {
        minHeight: +(event.target as any).minHeight?.value,
      }),
      ...(object.typeName === "button" && {
        buttonType: (event.target as any).buttonType?.value,
      }),
      ...(((object.typeName === "text" && textType === "other") ||
        object.typeName === "number" ||
        object.typeName === "decimalNumber") && {
        min: +(event.target as any).min?.value,
        max:
          +(event.target as any).max?.value > 0
            ? +(event.target as any).max?.value
            : null,
        minLengthBox: (event.target as any).minLengthBox?.value,
        maxLengthBox:
          +(event.target as any).maxLengthBox?.value > 0
            ? +(event.target as any).maxLengthBox?.value
            : null,
        setMaxLengthBox: (event.target as any).LengthTextBox?.value,
      }),
      ...(object.typeName === "date" && {
        DatePickerState: datePickerState,
        defaultValueDateTimeNow: (event.target as any)?.defaultValueDateTimeNow
          ?.checked,
      }),
      ...(object.typeName === "url" && {
        baseUrl: (event.target as any).baseUrl?.value,
        endpoint: (event.target as any).endpoint?.value,
        inputType: (event.target as any).inputType?.value,
        Keywords: keyWords,
        Keys: keys,
      }),
      ...(object.typeName === "Card" && {
        ////...((object.typeName === 'Step') && {
        isOpen: (event.target as any).isOpen?.checked,
        condition: (event.target as any).isOpen?.checked,
        stepNumber: (event.target as any).stepNumber?.value,
      }),
    };

    if (data.maxLength && object.typeName === "text") {
      if (indexTextBox === "text" && data?.maxLength > 500) {
        return Toast(trans("maxLengthText"), MessageType.error);
      }
      if (object?.typeName === "textArea" && data?.maxLength > 900) {
        return Toast(trans("maxLengthTextArea"), MessageType.error);
      }
    }

    if (data.maxLengthBox && data?.maxLengthBox < data?.minLengthBox) {
      return Toast(trans("maxLengthBoxmaxLengthBox"), MessageType.warning);
    }

    if (data.max && data.min && +data?.max < +data?.min) {
      return Toast(trans("maxMin"), MessageType.error);
    }

    if (keyWords.length === 0 && object.typeName === "selectBox") {
      return Toast(trans("msg_validation_valueisrequired"), MessageType.error);
    }
    if (keyWords.length <= 1 && object.typeName === "RadioButton") {
      return Toast(trans("Msg_RadioButtonMinimumOptions"), MessageType.error);
    }

    if (
      object.typeName !== "emptySpace" &&
      object.typeName !== "Message" &&
      [...systemKeys.flatMap((item) => item.inputList), ...systemKeys].find(
        (item) =>
          item.SystemKey === data.SystemKey &&
          object?.SystemKey !== item.SystemKey
      )
    ) {
      Toast(
        trans("duplicatekey").replace(
          "{0}",
          (event.target as any).SystemKey?.value
        ),
        MessageType.error
      );
    } else {
      handleNewSetting(
        data,
        (event.target as any).Formula?.value
          ? {
              [object?.SystemKey]: transformFormula(
                (event.target as any).Formula?.value
              ),
            }
          : null,
        (event.target as any).condition?.value != undefined
          ? {
              //// (
              ////  object?.typeName === 'Step')
              // || object?.typeName === 'Card')
              ////  ?
              [////  object.StepIndex :
              object?.SystemKey]: transformFormula(
                (event.target as any).condition?.value,
                true
              ),
            }
          : null,
      );
      // handleNewSetting(data , (event.target as any).Formula?.value ?  {[object?.SystemKey]:transformFormula((event.target as any).Formula?.value)}:{}, (event.target as any).condition?.value!=undefined ?  {[(object?.typeName === 'Step'||object?.typeName === 'Card') ?object.StepIndex :object?.SystemKey ]:'DynamicFormData.SupervisorInformation?.length > "2" '}:{});
      onHide(false);
    }
  };

  useEffect(() => {
    setMinLengthBox(null);
    setMaxLengthBox(null);
    setModeTextBox("create");
    if (indexTextBox === "number") {
      setTextType("number");
    } else if (indexTextBox === "tel") {
      setMinLengthBox(1);
      setMaxLengthBox(15);
      setModeTextBox("view");
      setTextType("other");
    } else if (
      indexTextBox === "mobile" ||
      indexTextBox === "nationalCode" ||
      indexTextBox === "nationalIdentifier" ||
      indexTextBox === "PostalCode"
    ) {
      setMinLengthBox(10);
      setMaxLengthBox(10);
      setModeTextBox("view");
      setTextType("other");
    } else if (indexTextBox === "birthCertNo") {
      setMinLengthBox(1);
      setMaxLengthBox(10);
      setModeTextBox("view");
      setTextType("other");
    } else if (indexTextBox === "econNo") {
      setMinLengthBox(10);
      setMaxLengthBox(14);
      setModeTextBox("view");
      setTextType("other");
    } else {
      setTextType("text");
    }
  }, [indexTextBox]);

  useEffect(() => {
    if (resetForm) {
      setResetForm(false);
    }
  }, [resetForm]);
  useEffect(() => {
    let newInputTextType: any = JSON.parse(JSON.stringify(InputTextType));
    delete newInputTextType[1];
    delete newInputTextType[6];
    setListTypeText(newInputTextType);
  }, []);
useEffect(()=>{
  if(object?.typeName === "apiRequestConfigurator"){
    getControllerLookupConfigApi()
  }
},[])

useEffect(()=>{
if(url?.baseUrl && url?.endpoint && object?.typeName === "apiRequestConfigurator"){
  getControllerLookupConfigDataAsync()
}
},[url])

  return (
    <form className="h-100" onSubmit={handleSubmit}>
      <div className="h-100">
        {/* <div className="text-primary-emphasis alert alert-primary py-2 border-0 rounded-0 d-flex justify-content-center align-items-center">{trans(object.typeName)}</div> */}
        <div className="text-primary-emphasis alert alert-primary py-2 border-0 rounded-0 d-flex justify-content-center align-items-center">
          {InputAvailable.find((item) => item.typeName == object.typeName)
            ? trans(
                object?.typeName == "PositionDictionary"
                  ? trans("databox")
                  : object?.typeName
              )
            : trans("databox")}
          &nbsp;
          <small style={{ fontSize: "12px" }}>
            {(object?.typeName == "PositionDictionary" ||
              !InputAvailable.some(
                (item) => item?.typeName == object?.typeName
              )) &&
              `(${trans(object?.typeName)})`}
          </small>
        </div>

        <div className="card-body row">
          <BasicSettings
            object={object}
            defaultValueDateTimeNow={defaultValueDateTimeNow}
          />
          <PositionSettings object={object} />
          {object?.type == InputTypes.dataGrid && (
            <>
              <div className="col-12 mt-3">
                <Textbox
                  textboxType={"number"}
                  min={1}
                  textboxName={"tbodyLength"}
                  labelText="RowNumber"
                  defaultValue={
                    object?.tbodyLength && object?.tbodyLength != 0
                      ? object?.tbodyLength + ""
                      : "3"
                  }
                />
              </div>
            </>
          )}

          {(object?.typeName === "Person" ||
            object?.typeName == "Position" ||
            object?.typeName === "PositionDictionary") && (
            <div className="d-flex align-items-end  h-100">
              <CheckableButton
                type="checkbox"
                labelText="Defaultvalue_CurrentPosition"
                inputName="fillWithCurrent"
                defaultChecked={object?.fillWithCurrent || false}
                defaultValue={object?.fillWithCurrent || false}
              />
            </div>
          )}

          {object?.typeName == "button" ? (
            <div className="col-12">
              <SelectBox
                lable="type"
                selectType="select"
                name="buttonType"
                value={object?.buttonType}
                val={[
                  "primary",
                  "cancel",
                  "cancelFill",
                  "primaryFill",
                  "submit",
                ]}
                options={[
                  "آبی تو خالی",
                  "قرمز تو خالی",
                  "قرمز توپر",
                  "آبی تو پر",
                  "سبز",
                ]}
              />
            </div>
          ) : (
            ""
          )}
          {object?.typeName == "activityStatus" && (
            <div className="col-12">
              <EnumerationTypeSelect
                //value={editForm?.Status}
                // Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                value={object?.defaultValue ? +object?.defaultValue : 1}
                name="defaultValue"
                enumTypeSelect="ActivityStatus"
                label="defaultValue"
              />
            </div>
          )}

          <div className="col-12  my-3">
            <SelectBox
              lable="InputSize"
              selectType="select"
              name="size"
              value={
                object?.typeName !== "Step" && object?.typeName !== "Card"
                  ? object?.size
                  : 12
              }
              val={[2, 3, 4, 6, 8, 9, 10, 12]}
              options={[
                "15%",
                "25%",
                "33%",
                "50%",
                "66%",
                "75%",
                "85%",
                "100%",
              ]}
              mode={object?.typeName === "Step" ? "view" : "create"}
            />
          </div>
          {object?.typeName == "decimalNumber" && (
            <div className="my-1">
              <Textbox
                textboxType={"number"}
                textboxName="numberOfDecimal"
                labelText="NumberOfDecimalPlaces"
                defaultValue={4}
                min={0}
                readonly
              />
            </div>
          )}

          {object?.typeName == "attachment" && (
            <div className="my-1">
              <CheckableButton
                required={true}
                labelText={trans("msg_showintab")}
                inputName={object?.SystemKey}
                onchange={(e) => {

                }}
                //  mode={'view'}

                type="radio"
                useTrans={false}
                value={"tab"}
                defaultChecked={
                  object?.attachmentType === "tab" || !object?.attachmentType
                }
              />
              {/* <CheckableButton
             required={true}

             labelText={'نمایش در گالری'} 
             inputName={object?.SystemKey} 
              onchange={(e)=>{console.log(e);
              }}
            //  mode={ 'view'} 
             defaultChecked={object?.attachmentType==='gallery'}
             type="radio"
             useTrans={false}
              value={'gallery'}              
             /> */}
            </div>
          )}

          {object?.typeName != "RequesterPositionId" &&
            object?.typeName != "PositionDictionary" &&
            object?.SystemKey != "Description" &&
            object?.SystemKey != "SystemNumber" && (
              <div className="col-12 my-1">
                <Textbox
                  fixedLanguage={"en"}
                  textboxType={"text"}
                  sqlInjection={false}
                  textboxName="condition"
                  labelText="ShowCondition"
                  defaultValue={
                    condition?.[
                      ////               (
                      ////object?.typeName === 'Step'چون استپ و اوردیم روی کارد ولی دیتاها قدیمی بود و ساخت باکس با استپ بود مجبور شدم این خط و کامنت کنم
                      ////|| object?.typeName === 'Card'
                      ////)
                      ////   ?object.StepIndex :
                      object?.SystemKey
                    ]
                      ? condition[
                          /////  (
                          ////object?.typeName === 'Step'
                          ////||object?.typeName === 'Card'
                          ///// ) ?object.StepIndex :
                          object?.SystemKey
                        ]?.replaceAll("DynamicFormData.", "")
                      : ""
                  }
                />
              </div>
            )}

          {object?.typeName === "checkBox" && (
            <CheckboxSettings object={object} />
          )}
          {/* simpleGrid */}

          {object?.typeName == "simpleGrid" && (
            <>
              <div className="col-6">
                <Textbox
                  textboxType={"number"}
                  min={1}
                  textboxName={"tbodyLength"}
                  labelText="RowNumber"
                  defaultValue={object?.tbodyLength}
                />
              </div>
              <div className="col-6">
                <Textbox
                  textboxType={"number"}
                  min={1}
                  textboxName={"theadLength"}
                  labelText="theadLength"
                  defaultValue={object?.theadLength}
                />
              </div>
            </>
          )}
          {object?.typeName === "ProgressBar" && (
            <ProgressBarSettings object={object} resetForm={resetForm} />
          )}

          {object?.typeName === "price" && (
            <>
            <div className="row align-items-center">

              <div className="col-8 ">
                <p className="text-box__label showDots">

{trans("NumberOfDecimalPlaces")+":"}
                </p>
              </div>
               <div className="col-4 px-0">
                <Textbox
                  textboxName={"CurrencyRoundingPlace"}
                  textboxType="number"
                  min={0}
                  withLabel={false}
                  labelText={"NumberOfDecimalPlaces"}
                  defaultValue={
                    object?.currencyRoundingPlace
                      ? object?.currencyRoundingPlace + ""
                      : object?.currencyRoundingPlace == 0
                      ? "0"
                      : 2
                  }
                  max={4}
                />
              </div>
            </div>  
              <div className="col-12">
                <PriceSettings object={object} />
              </div>
            </>
          )}

          {object?.typeName === "Message" && (
            <MessageSettings object={object} />
          )}

          {object?.typeName === "RadioButton" && (
            <RadioSelectSettings
              direction={direction}
              setDirection={setDirection}
              object={object}
            />
          )}

          {(object?.typeName === "RadioButton" ||
            object?.typeName === "selectBox") && (
            <KeyWord
              name="KeyWords"
              label="options"
              withSystemKey={true}
              setKeyWords={setKeyWords}
              keyWords={keyWords}
              required={true}
              defaultValue={object?.KeyWords}
            />
          )}
          {object?.typeName === "selectBox" && !!keyWords?.length ? (
            <SelectBox
              lable="defaultValue"
              selectType="select"
              name="defaultValue"
              value={object?.defaultValue}
              val={keyWords.map((item) => item.SystemKey)}
              options={keyWords.map((item) => item.name)}
              mode={object?.typeName === "Step" ? "view" : "create"}
              isDisabled={!keyWords?.length}
            />
          ) : (
            <></>
          )}

          {object?.SystemKey == "SystemNumber" ? (
            <div className="col-12">
              <Textbox
                textboxType={"text"}
                textboxName="defaultValue"
                labelText="defaultValue"
                defaultValue={object?.defaultValue}
              />
            </div>
          ) : (
            <></>
          )}

          {(object?.typeName === "Position" ||
            (object?.typeName === "PositionDictionary" &&
              object?.SystemKey === "RequesterPositionId")) && (
            <div className="col-12 mb-1">
              <EnumerationTypeSelect
                label="OrganizationType"
                name="OrganizationType"
                value={object?.OrganizationType}
                mode={modeTextBox}
                enumTypeSelect="OrganizationType"
              />
            </div>
          )}

          {((object?.typeName === "text" &&
            object?.SystemKey !== "RequesterPositionId") ||
            object?.typeName === "textArea" ||
         //   object?.typeName === "items" ||

            object?.typeName === "number" ||
            object?.typeName === "apiRequestConfigurator" ||
            object?.typeName === "decimalNumber" ||
            object.typeName == "SystemNumber" ||
            object?.typeName === "price") && (
            <TextInputSettings
              object={object}
              Formul={Formul}
              textType={textType}
              modeTextBox={modeTextBox}
              listTypeText={listTypeText}
              checkTypeText={checkTypeText}
              minLengthBox={minLengthBox}
              maxLengthBox={maxLengthBox}
              systemKeys={systemKeys}
            />
          )}

          {object?.typeName === "Card" && (
            <Textbox
              textboxType={"text"}
              textboxName="stepNumber"
              labelText="stepNumber"
              defaultValue={object?.stepNumber}
            />
          )}
{
  object?.typeName === "apiRequestConfigurator" && 
<>

     <div className="col-12 mb-3">
                <SelectBox
                  lable="نام سرویس"
                  selectType="select"
                  onChange={(e) => {
                    console.log('fffffffffffffffff');
                    
                    setUrl({...url,baseUrl:e.target.value})
                  }}
                  name="serviceName"
                  value={
                    object?.serviceName
                      ? object?.serviceName
                      :                   Object.values(AvailableService)[0]

                  }
                  val={
                  Object.values(AvailableService)

                  }
                  options={
                  Object.keys(AvailableService)

                  }
                  mode={"create"}
                />
              </div>
              
     <div className="col-12 mb-3">
      {
        controllerLookupConfigLoading?
        
          <SelectBox
                  lable="نام کنترلر"
                  selectType="select"
                  onChange={(e) => {
                    setUrl({...url,endpoint:e.target.value})
                  }}
                  name="controllerLookupConfig"
                  value={
                    object?.controllerLookupConfig
                      ? object?.controllerLookupConfig
                      :           controllerLookupConfig?.map(item=>item.dropDownUrl)[0]


                  }
                  val={
                                  controllerLookupConfig?.map(item=>item.dropDownUrl)

                  }
                  options={
                 controllerLookupConfig?.map(item=>item.Description)

                  }
                  mode={"create"}
                />
        :
          <InputLoad
                  labelText="نام کنترلر"
                  onClick={getControllerLookupConfigApi}
          />
      }          
              </div>
</>
}

          {(object?.typeName === "date" || object?.typeName === "time") && (
            <DateTimeSettings
              object={object}
              datePickerState={datePickerState}
              setDatePickerState={setDatePickerState}
              defaultValueDateTimeNow={defaultValueDateTimeNow}
              setDefaultValueDateTimeNow={setDefaultValueDateTimeNow}
              setDateDefaultValue={setDateDefaultValue}
              resetForm={resetForm}
            />
          )}

          {object?.typeName === "url" && (
            <>
              <div className="col-12 mb-3">
                <SelectBox
                  lable="inputType"
                  selectType="select"
                  onChange={(e) => {
                    setInputTypeUrl(e.target.value);
                  }}
                  name="inputType"
                  value={
                    object?.inputType
                      ? object?.inputType
                      : "AutoCompleteDictionary"
                  }
                  val={[
                    "AutoCompleteDictionary",
                    "SelectBox",
                    "MultiSelectBox",
                  ]}
                  options={[
                    "AutoCompleteDictionary",
                    "SelectBox",
                    "MultiSelectBox",
                  ]}
                  mode={"create"}
                />
              </div>
              {inputTypeUrl == "MultiSelectBox" ? (
                <div className="col-12">
                  <small className="text-box__label showDots">
                    کلید مقدار درخواستی
                  </small>
                  <KeyWord
                    name="Keys"
                    label="key"
                    withSystemKey={false}
                    setKeyWords={setKeys}
                    keyWords={keys}
                    required={true}
                    defaultValue={object?.Keys}
                  />
                </div>
              ) : (
                <></>
              )}
              <div className="col-12">
                <Textbox
                  textboxType={"text"}
                  textboxName="baseUrl"
                  labelText="آدرس اصلی سرویس"
                  defaultValue={object.baseUrl}
                  required
                />
              </div>
              <div className="col-12">
                <Textbox
                  textboxType={"text"}
                  textboxName="endpoint"
                  labelText="مسیر نقطه دسترسی (Endpoint)"
                  defaultValue={object?.endpoint}
                  required
                />
              </div>
              <div className="col-12">
                <small className="text-box__label showDots">
                  پارامترهای API
                </small>
                <KeyWord
                  name="KeyWords"
                  label="key"
                  label2="value"
                  withSystemKey={true}
                  setKeyWords={setKeyWords}
                  keyWords={keyWords}
                  required={true}
                  defaultValue={object?.KeyWords}
                />
              </div>
            </>
          )}

          {object?.typeName === "timeLength" && (
            <TimeLengthSettings object={object} />
          )}

          <div className="col-lg-12 mt-1 btns_form">
            <Button btnType="submit" value="confirm" />
            <Button
              btnType="cancel"
              value="cancel"
              onClick={() => onHide(false)}
            />
          </div>
        </div>
      </div>
    </form>
  );
};
